import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Menu from '../menu/Menu';
import Header from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import CongregacoesService from '../../service/congregacoes';
import UsuarioService from '../../service/usuario';
import Titulo from '../titulo/Titulo';
///teste
const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  margin-top: 85px;
  margin-bottom: 50px;
`;

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 240px;
  padding: clamp(1rem, 2vh, 1.5rem) clamp(1rem, 2.5vw, 2rem);
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: clamp(1rem, 4vw, 2rem);
  }

  @media (min-width: 768px) and (max-width: 1200px) {
    margin-left: 60px;
  }
`;

const CorpoDaPagina = styled.div`
  font-family: "Roboto", sans-serif;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const Card = styled.section`
  width: 100%;
  max-width: 800px;
  margin: 0 auto 24px; /* explicit bottom margin so last element never touches footer */
  padding: 40px 60px 56px; /* remove excessive bottom padding; rely on PageWrapper padding + margin */
  background: #fff;
  border: 1px solid #bdbdbd;
  box-shadow: #bdbdbd 0 5px 15px;
  border-radius: 12px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 36px 48px 52px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 32px 32px 48px;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  @media (max-width: 600px) {
    padding: 28px 24px 44px;
    box-shadow: #bdbdbd 0 3px 10px;
    margin-bottom: 18px;
  }

  @media (max-width: 400px) {
    padding: 24px 16px 40px;
    border-radius: 8px;
    margin-bottom: 16px;
  }
`;

// Typography
const Heading = styled.h3`
  font-weight: 800;
  color: #58585b;

  @media (max-width: 768px) {
    font-size: clamp(16px, 4vw, 20px);
  }
`;

const Publicador = styled.h3`
  font-weight: 800;
  color: #58585b;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: clamp(16px, 4vw, 20px);
  }
`;

const Label = styled.label`
  color: #58585b;

  @media (max-width: 768px) {
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const FormularioContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  padding: clamp(20px, 4vw, 25px);
  position: relative;
  border: 1px solid #bdbdbd;
  box-shadow: #bdbdbd 0px 5px 15px;
  border-radius: 8px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const FieldGroup = styled.div`
  margin-bottom: 15px;
`;

const InputBase = styled.input`
  width: 100%;
  height: 32px;
  margin-top: 5px;
  padding: 6px 10px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.2;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 14px;
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const Select = styled.select`
  width: 100%;
  height: 42px;
  padding: 10px 14px;
  padding-right: 42px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
  background: #fff;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='18' height='18'><path d='M7 10l5 5 5-5' stroke='%23333' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 14px center;
  background-size: 18px 18px;
  transition: border-color .15s ease, box-shadow .15s ease;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #008080;
    box-shadow: 0 0 0 3px rgba(0, 128, 128, .2);
  }
  
  @media (max-width: 400px) {
    height: 40px;
    padding: 8px 12px;
    padding-right: 40px;
    font-size: 13px;
    background-position: right 12px center;
  }
`;

const ButtonBar = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-start;
  
  @media (max-width: 600px) {
    margin-top: 20px;
  }
`;

const SubmitBtn = styled.button`
  all: unset;
  padding: 12px 48px;
  border-radius: 8px;
  background: #008080;
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: .95rem;
  font-weight: 500;
  cursor: pointer;
  letter-spacing: .5px;
  transition: .2s background-color, .15s transform;
  text-align: center;
  
  &:hover {
    background: #00aaaa;
  }
  
  &:active {
    transform: scale(.97);
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    padding: 11px 42px;
    font-size: .9rem;
  }
  
  @media (max-width: 600px) {
    width: 100%;
    padding: 12px 24px;
  }
  
  @media (max-width: 400px) {
    padding: 11px 20px;
    font-size: .85rem;
  }
`;

// Messages
const MessageBox = styled.div`
  position: absolute;
  right: 24px;
  top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: 420px;

  @media (max-width: 768px) {
    position: static;
    align-items: stretch;
    max-width: 100%;
    margin-bottom: 16px;
  }
`;

const Formulario = styled.form`
  margin-top: 15px;
`;

const NomeContainer = styled.div`
  margin-bottom: 15px;
`;

const LinhaNomes = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const Coluna = styled.div`
  flex: 1;
`;

const Nome = styled.input`
  width: 100%;
  height: 32px;
  margin-top: 5px;
  padding: 6px 10px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.2;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 14px;
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const EmailContainer = styled.div`
  margin-bottom: 15px;
`;

const TelefoneContainer = styled.div`
  margin-bottom: 15px;
`;

const CongregacaoContainer = styled.div`
  margin-bottom: 15px;
`;

const Email = styled.input`
  width: 100%;
  height: 32px;
  margin-top: 5px;
  padding: 6px 10px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.2;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 14px;
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const Telefone = styled.input`
  width: 100%;
  height: 32px;
  margin-top: 5px;
  padding: 6px 10px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.2;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 14px;
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const Congregacao = styled.select`
  width: 100%;
  height: 32px;
  margin-top: 5px;
  padding: 6px 10px 6px 10px;
  padding-right: 36px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.2;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16'><path d='M7 10l5 5 5-5' stroke='%23333' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 40px 10px 14px;
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const Perfil = styled.select`
  width: 100%;
  height: 32px;
  margin-top: 5px;
  padding: 6px 10px 6px 10px;
  padding-right: 36px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.2;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16'><path d='M7 10l5 5 5-5' stroke='%23333' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;

  @media (max-width: 768px) {
    height: 40px;
    padding: 10px 40px 10px 14px;
    font-size: clamp(14px, 3.5vw, 16px);
  }
`;

const Botao = styled.button`
  all: unset;
  padding: 7px 50px;
  margin-top: 25px;
  border-radius: 8px;
  margin-left: 270px;
  background-color: #008080;
  color: white;
  font-family: "Inter", sans-serif;
  font-weight: 350;
  font-size: 0.8rem;
  cursor: pointer;

  &:hover {
    background-color: #00aaaa;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    padding: 12px;
    text-align: center;
    font-size: clamp(15px, 3.8vw, 17px);
  }
`;

const MessageSuccess = styled.div`
  color: #0a7a4a;
  background: #e6ffef;
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid #c7efd6;
  display: inline-block;
  margin-left: 35px;

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    text-align: center;
    font-size: clamp(13px, 3.2vw, 15px);
  }
`;

const MessageError = styled.div`
  color: #c53030;
  background: #ffecec;
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid #f1c2c2;
  display: inline-block;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: clamp(13px, 3.2vw, 15px);
  }
`;

const CadastrarPublicador = () => {
  // State
  const [congregacoes, setCongregacoes] = useState([]);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [congregacaoId, setCongregacaoId] = useState('');
  const [perfil, setPerfil] = useState('');
  const [checkedPerfis, setCheckedPerfis] = useState({
    publicador: false,
    coordenadorGeral: false,
    coordenadorPonto: false,
    coordenadorRegional: false,
    colaborador: false,
    secretaria: false,
  });
  const [checkedPrivilegios, setCheckedPrivilegios] = useState({
    anciao: false,
    servoMinisterial: false,
    pioneiroRegular: false,
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [ddi, setDdi] = useState('+55');
  const [filtroCircuito, setFiltroCircuito] = useState('');
  
  const LISTA_DDI = [
  { code: '+93', pais: 'Afeganistão' }, { code: '+27', pais: 'África do Sul' }, { code: '+355', pais: 'Albânia' },
  { code: '+49', pais: 'Alemanha' }, { code: '+376', pais: 'Andorra' }, { code: '+244', pais: 'Angola' },
  { code: '+54', pais: 'Argentina' }, { code: '+61', pais: 'Austrália' }, { code: '+43', pais: 'Áustria' },
  { code: '+32', pais: 'Bélgica' }, { code: '+591', pais: 'Bolívia' }, { code: '+55', pais: 'Brasil' },
  { code: '+359', pais: 'Bulgária' }, { code: '+238', pais: 'Cabo Verde' }, { code: '+1', pais: 'Canadá / EUA' },
  { code: '+56', pais: 'Chile' }, { code: '+86', pais: 'China' }, { code: '+57', pais: 'Colômbia' },
  { code: '+82', pais: 'Coreia do Sul' }, { code: '+506', pais: 'Costa Rica' }, { code: '+53', pais: 'Cuba' },
  { code: '+45', pais: 'Dinamarca' }, { code: '+20', pais: 'Egito' }, { code: '+503', pais: 'El Salvador' },
  { code: '+971', pais: 'Emirados Árabes' }, { code: '+593', pais: 'Equador' }, { code: '+34', pais: 'Espanha' },
  { code: '+33', pais: 'França' }, { code: '+30', pais: 'Grécia' }, { code: '+502', pais: 'Guatemala' },
  { code: '+509', pais: 'Haiti' }, { code: '+31', pais: 'Holanda' }, { code: '+504', pais: 'Honduras' },
  { code: '+91', pais: 'Índia' }, { code: '+353', pais: 'Irlanda' }, { code: '+972', pais: 'Israel' },
  { code: '+39', pais: 'Itália' }, { code: '+81', pais: 'Japão' }, { code: '+52', pais: 'México' },
  { code: '+258', pais: 'Moçambique' }, { code: '+505', pais: 'Nicarágua' }, { code: '+47', pais: 'Noruega' },
  { code: '+64', pais: 'Nova Zelândia' }, { code: '+507', pais: 'Panamá' }, { code: '+595', pais: 'Paraguai' },
  { code: '+51', pais: 'Peru' }, { code: '+48', pais: 'Polônia' }, { code: '+351', pais: 'Portugal' },
  { code: '+44', pais: 'Reino Unido' }, { code: '+420', pais: 'Rep. Tcheca' }, { code: '+7', pais: 'Rússia' },
  { code: '+46', pais: 'Suécia' }, { code: '+41', pais: 'Suíça' }, { code: '+597', pais: 'Suriname' },
  { code: '+598', pais: 'Uruguai' }, { code: '+58', pais: 'Venezuela' }
]; // Encurtei algumas strings enormes para caberem bem no ecrã.



  // Esta é a regra oculta que formata visualmente e proíbe o zero inicial!
  const handleTelefoneChange = (e) => {
    // Tira tudo que não for número digitado
    let valor = e.target.value.replace(/\D/g, ''); 

    // Bloqueia se a pessoa tentar começar o DDD com ZERO
    if (valor.startsWith('0')) {
      valor = valor.substring(1);
    }

    // Limita ao máximo de 11 números (2 do DDD + 9 do celular)
    if (valor.length > 11) {
      valor = valor.substring(0, 11);
    }

    // Aplica a máscara visual lindamente: (XX) XXXXX-XXXX
    let mascara = valor;
    if (valor.length > 2 && valor.length <= 6) {
      mascara = `(${valor.substring(0, 2)}) ${valor.substring(2)}`;
    } else if (valor.length > 6 && valor.length <= 10) {
      mascara = `(${valor.substring(0, 2)}) ${valor.substring(2, 6)}-${valor.substring(6)}`;
    } else if (valor.length === 11) {
      mascara = `(${valor.substring(0, 2)}) ${valor.substring(2, 7)}-${valor.substring(7)}`;
    } else if (valor.length > 0 && valor.length <= 2) {
      mascara = `(${valor}`; // Começa a abrir o parêntese
    }

    setTelefone(mascara);
    setErrorMessage('');
  };





  // Load congregations
  useEffect(() => { (async () => {
    try { 
      const data = await CongregacoesService.getCongregacoes(); 
      const sorted = Array.isArray(data) ? data.sort((a, b) => {
        const nomeA = (a.nome || '').toLowerCase();
        const nomeB = (b.nome || '').toLowerCase();
        return nomeA.localeCompare(nomeB, 'pt-BR');
      }) : [];
      setCongregacoes(sorted);
    }
    catch { setCongregacoes([]); }
  })(); }, []);

  // Validation helpers
  const emailRegex = new RegExp("^(?=[a-zA-Z0-9._%+-]*[a-zA-Z])[a-zA-Z0-9._%+-]+@(?:(?=[a-zA-Z0-9-]*[a-zA-Z])[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$");
  const dominiosComuns = [
    'gmail.com','outlook.com','outlook.com.br','hotmail.com','yahoo.com','yahoo.com.br','yahoo.co.uk','tpedf.com.br','tpedf.com','ifb.edu.br','live.com','icloud.com','me.com','msn.com','protonmail.com','proton.me','aol.com','zoho.com','mail.com','gmx.com','yandex.com','uol.com.br','bol.com.br','terra.com.br','ig.com.br'
  ];
  function lev(a,b){const m=[];for(let i=0;i<=b.length;i++)m[i]=[i];for(let j=0;j<=a.length;j++)m[0][j]=j;for(let i=1;i<=b.length;i++){for(let j=1;j<=a.length;j++){m[i][j]=b[i-1]===a[j-1]?m[i-1][j-1]:Math.min(m[i-1][j-1]+1,m[i][j-1]+1,m[i-1][j]+1);}}return m[b.length][a.length];}
  function validarDominio(v){const d=v.split('@')[1];if(!d)return 'Digite um e-mail válido.';if(dominiosComuns.includes(d))return '';let md=Infinity,close='';dominiosComuns.forEach(dom=>{const dist=lev(d,dom);if(dist<md){md=dist;close=dom;}});if(md<=2)return `E-mail inválido. Você quis dizer @${close}?`;return 'Digite um e-mail válido.';}
  function validarSufixo(v){const d=v.split('@')[1];if(!d)return 'Digite um e-mail válido.';if(d==='gmail.com.br')return 'Digite um e-mail válido.';const partes=d.split('.');if(partes.length<2)return 'Digite um e-mail válido.';const suf=partes.slice(1).join('.').toLowerCase();const comuns=['com','com.br'];let md=Infinity;comuns.forEach(s=>{const dist=lev(suf,s);if(dist<md)md=dist;});if(md<=2 && !comuns.includes(suf))return 'Digite um e-mail válido.';const ult=partes[partes.length-1];if(ult.length<2||ult.length>10)return 'Digite um e-mail válido.';if(!/^[a-z0-9.-]+$/.test(d))return 'Digite um e-mail válido.';return '';}
  function validarEmail(v){const valor=v.trim();if(!emailRegex.test(valor))return 'Digite um e-mail válido.';const dm=validarDominio(valor);if(dm)return dm;const sm=validarSufixo(valor);if(sm)return sm;return '';}
  function validarTelefone(v){const valor=v.trim();const numMais=valor.replace(/[^\d+]/g,'');if(!/^[+]?\d+$/.test(numMais))return 'Digite um telefone válido.';const numeros=numMais.replace(/\+/g,'');if(numeros.length<7)return 'Digite um telefone válido.';if(numeros.length>15)return 'Número de telefone inválido.';const ehBrasil=valor.startsWith('+55')||(numeros.length>=10 && numeros.length<=11 && !valor.startsWith('+'));if(ehBrasil){const semPais=valor.startsWith('+55')?numeros.substring(2):numeros;if(semPais.length<10||semPais.length>11)return 'Telefone brasileiro deve ter 10 ou 11 dígitos (DDD + número).';const ddd=parseInt(semPais.substring(0,2));const ddds=[11,12,13,14,15,16,17,18,19,21,22,24,27,28,31,32,33,34,35,37,38,41,42,43,44,45,46,47,48,49,51,53,54,55,61,62,64,63,65,66,67,68,69,71,73,74,75,77,79,81,87,82,83,84,85,88,86,89,91,93,94,92,97,95,96,98,99];if(!ddds.includes(ddd))return 'DDD inválido. Digite um DDD válido do Brasil.';const numero=semPais.substring(2);if(semPais.length===11 && parseInt(numero[0])!==9)return 'Celular brasileiro deve começar com 9 após o DDD.';if(semPais.length===10 && ['9','0','1'].includes(numero[0]))return 'Telefone fixo brasileiro não pode começar com 9, 0 ou 1.';}return '';}
  function validarNome(v){const valor=v.trim();if(!valor)return 'Digite o nome completo.';if(valor.length>100)return 'O nome completo deve ter no máximo 100 caracteres.';const rg=/^[a-zA-ZÀ-ÿ\s'-]+$/;if(!rg.test(valor))return 'O nome não pode conter números ou caracteres especiais.';const partes=valor.split(/\s+/).filter(Boolean);for(const p of partes){if(p.length<2)return 'Cada parte do nome deve ter no mínimo 2 caracteres.';if(p.length>50)return 'Cada parte do nome deve ter no máximo 50 caracteres.';}if(partes.length<2)return 'Digite o nome e sobrenome.';return '';}

  const handlePerfilCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckedPerfis((prev) => ({ ...prev, [name]: checked }));
  };

  const handlePrivilegioCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckedPrivilegios((prev) => ({ ...prev, [name]: checked }));
  };

  const perfilLabelMap = {
    publicador: 'publicador',
    coordenadorGeral: 'coordenador-geral',
    coordenadorPonto: 'coordenador-ponto',
    coordenadorRegional: 'coordenador-regional',
    colaborador: 'colaborador',
    secretaria: 'secretaria',
  };

  const privilegioLabelMap = {
    anciao: 'anciao',
    servoMinisterial: 'servo-ministerial',
    pioneiroRegular: 'pioneiro-regular',
  };

  const resolvePerfil = () =>
    Object.entries(checkedPerfis)
      .filter(([, checked]) => checked)
      .map(([key]) => perfilLabelMap[key]);

  const resolvePrivilegio = () =>
    Object.entries(checkedPrivilegios)
      .filter(([, checked]) => checked)
      .map(([key]) => privilegioLabelMap[key]);

  const circuitosUnicos = [...new Set(congregacoes
    .map(cong => cong.circuito)
    .filter(Boolean)
    .filter(circuito => circuito !== 'SC')
  )].sort();

  const congregacoesFiltradas = filtroCircuito
    ? congregacoes.filter(cong => cong.circuito === filtroCircuito)
    : congregacoes.filter(cong => cong.circuito !== 'SC');

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault(); setSuccessMessage(''); setErrorMessage('');
    const eNome = validarNome(nome); if(eNome){ setErrorMessage(eNome); return; }
    const eEmail = validarEmail(email); if(eEmail){ setErrorMessage(eEmail); return; }
    const eTel = validarTelefone(telefone); if(eTel){ setErrorMessage(eTel); return; }
    const perfilSelecionado = resolvePerfil();
    if (perfilSelecionado.length === 0) {
      setErrorMessage('Selecione pelo menos um perfil.');
      return;
    }

    const ddiLimpo = ddi.replace(/\D/g, ''); // Transforma '+55' em '55'
    const numeroLimpo = telefone.replace(/\D/g, '');
    const ddd = parseInt(numeroLimpo.substring(0, 2));
    const ddds = [11,12,13,14,15,16,17,18,19,21,22,24,27,28,31,32,33,34,35,37,38,41,42,43,44,45,46,47,48,49,51,53,54,55,61,62,64,63,65,66,67,68,69,71,73,74,75,77,79,81,87,82,83,84,85,88,86,89,91,93,94,92,97,95,96,98,99];
    if (!ddds.includes(ddd)) {
      setErrorMessage("DDD inválido. Digite um DDD do Brasil.");
      return;
    }

    // Junta o DDI (só números) com o Telefone (só números)
    const telefoneFinalBanco = `${ddiLimpo}${numeroLimpo}`; 
    // --------------------------------------------
    
    setLoading(true);
    try {
      const fullName = nome.trim().replace(/\s+/g,' ').trim();
      const telefoneApenasNumeros = telefone.replace(/\D/g,'');

      // Lógica de geração de username igual ao script gerarUsuario.js
      const preposicoes = ["de", "da", "do", "das", "dos"];
      function removerAcentos(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      }
      function gerarUsernameBase(nomeCompleto) {
        const partes = nomeCompleto
          .trim()
          .toLowerCase()
          .split(/\s+/)
          .map(removerAcentos)
          .filter((p) => !preposicoes.includes(p));
        if (partes.length === 0) return "usuario";
        const primeiraLetra = partes[0][0];
        const ultimoSobrenome = partes[partes.length - 1];
        return primeiraLetra + ultimoSobrenome;
      }
      const usuarioGerado = gerarUsernameBase(fullName);

      const payload = {
        nome: fullName,
        usuario: usuarioGerado,
        email: email.trim(),
        telefone: telefoneApenasNumeros,
        congregacao: congregacaoId,
        perfil: perfilSelecionado,
        privilegio: resolvePrivilegio(),
        observacao: '',
        ativo: true,
        treinamento: false,
  };
      const novoUsuario = await UsuarioService.createUsuario(payload);
      setSuccessMessage(`Usuário ${novoUsuario.nome} criado com sucesso!`);

      setTimeout(()=>setSuccessMessage(''),5000);
      setNome(''); setEmail(''); setTelefone(''); setCongregacaoId('');
      setCheckedPerfis({ publicador: false, coordenadorGeral: false, coordenadorPonto: false, coordenadorRegional: false, colaborador: false, secretaria: false });
      setCheckedPrivilegios({ anciao: false, servoMinisterial: false, pioneiroRegular: false });
    } catch(err){
      const serverMsg = err && err.response && err.response.data && err.response.data.erro ? err.response.data.erro : err?.message || 'Erro ao criar usuário';
      setErrorMessage(serverMsg); setTimeout(()=>setErrorMessage(''),4000);
    } finally { setLoading(false); }
  };

  return (
    <PageWrapper>
      <Header />
      <Menu />
      <MainContentWrapper>
        <Container>
          <CorpoDaPagina>
            <Titulo>Cadastrar Publicador</Titulo>

            <FormularioContainer>
          <Publicador>Dados do Publicador</Publicador>

          <MessageBox>
            {successMessage && <MessageSuccess>{successMessage}</MessageSuccess>}
            {errorMessage && <MessageError>{errorMessage}</MessageError>}
          </MessageBox>
          <form onSubmit={handleSubmit}>
            <FieldGroup>
              <Label>Nome Completo</Label>
              <InputBase
                type='text'
                name='nome'
                value={nome}
                placeholder='Exemplo: João Silva'
                maxLength={100}
                required
                onChange={e=>{ setNome(e.target.value); setErrorMessage(''); }}
                onBlur={e=>{ const v = validarNome(e.target.value); if(v) setErrorMessage(v); }}
              />
            </FieldGroup>

            <FieldGroup>
              <Label>E-mail</Label>
              <InputBase
                type='email'
                name='email'
                value={email}
                placeholder='joao.silva@gmail.com'
                required
                onChange={e=>setEmail(e.target.value)}
              />
            </FieldGroup>

            <FieldGroup>
              <Label>Telefone</Label>
              <div style={{ display: 'flex', gap: '8px', marginTop: '5px' }}>
                <select
                  value={ddi}
                  onChange={e => setDdi(e.target.value)}
                  style={{ height: '32px', border: '1px solid #bdbdbd', borderRadius: '3px', fontSize: '13px', padding: '0 6px', background: '#fff', minWidth: '130px' }}
                >
                  {LISTA_DDI.map(d => (
                    <option key={d.code} value={d.code}>{d.code} ({d.pais})</option>
                  ))}
                </select>
                <InputBase
                  type='tel'
                  name='telefone'
                  value={telefone}
                  placeholder='(61) 99999-9999'
                  required
                  style={{ marginTop: 0, flex: 1 }}
                  onChange={handleTelefoneChange}
                />
              </div>
            </FieldGroup>

            <FieldGroup>
              <Label>Circuito</Label>
              <Select
                value={filtroCircuito}
                onChange={e => { setFiltroCircuito(e.target.value); setCongregacaoId(''); }}
              >
                <option value=''>Todos os circuitos</option>
                {circuitosUnicos.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </Select>
            </FieldGroup>

            <FieldGroup>
              <Label>Congregação</Label>
              <Select
                name='congregacao'
                value={congregacaoId}
                required
                onChange={e=>setCongregacaoId(e.target.value)}
              >
                <option value=''>Selecione a congregação</option>
                {congregacoesFiltradas.map(c=> <option key={c._id || c.id} value={c._id || c.id}>{c.nome}</option> )}
              </Select>
              {congregacoesFiltradas.length === 0 && filtroCircuito && (
                <span style={{ fontSize: '12px', color: '#888', marginTop: '4px', display: 'block' }}>Nenhuma congregação encontrada para este circuito.</span>
              )}
            </FieldGroup>

            <FieldGroup>
              <Label>Perfil</Label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '8px' }}>
                {[
                  { name: 'publicador', label: 'Publicador' },
                  { name: 'coordenadorGeral', label: 'Coordenador Geral' },
                  { name: 'coordenadorPonto', label: 'Coordenador de Ponto' },
                  { name: 'coordenadorRegional', label: 'Coordenador Regional' },
                  { name: 'colaborador', label: 'Colaborador' },
                  { name: 'secretaria', label: 'Secretária' },
                ].map(({ name, label }) => (
                  <label key={name} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#222' }}>
                    <input
                      type='checkbox'
                      name={name}
                      checked={checkedPerfis[name]}
                      onChange={handlePerfilCheckboxChange}
                    />
                    {label}
                  </label>
                ))}
              </div>
            </FieldGroup>

            <FieldGroup>
              <Label>Privilégio</Label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '8px' }}>
                {[
                  { name: 'anciao', label: 'Ancião' },
                  { name: 'servoMinisterial', label: 'Servo Ministerial' },
                  { name: 'pioneiroRegular', label: 'Pioneiro Regular' },
                ].map(({ name, label }) => (
                  <label key={name} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#222' }}>
                    <input
                      type='checkbox'
                      name={name}
                      checked={checkedPrivilegios[name]}
                      onChange={handlePrivilegioCheckboxChange}
                    />
                    {label}
                  </label>
                ))}
              </div>
            </FieldGroup>
            <ButtonBar>
              <SubmitBtn type='submit' disabled={loading}>
                {loading ? "Salvando..." : "Salvar"}
              </SubmitBtn>
            </ButtonBar>
          </form>
        </FormularioContainer>
          </CorpoDaPagina>
        </Container>
      </MainContentWrapper>
      <Rodape />
    </PageWrapper>
  );
};

export default CadastrarPublicador;